import { put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import { GET_USERPROFILE_SUCCESS, GET_USERPROFILE_FAILURE } from '../actions';
import { updateCurrencyCode } from 'src/utils/util';
import {
    BASESITEID,
    JAPAN_SALESORG,
    US_COUNTRY_CODE,
    US_CURRENCY_CODE,
    US_LANGUAGE_CODE,
    IMPERSONATED_URL,
} from 'src/constants/appConstants';
import i18n from 'src/i18n';

export default function* getUserProfile() {
    const url = IMPERSONATED_URL;
    try {
        const result = yield axios.get(url).then((response) => response.data);
        localStorage.setItem('baseSiteId', result.baseSiteId || BASESITEID);
        localStorage.setItem(
            'currencyISOCode',
            result.currencyISOCode || US_CURRENCY_CODE
        );
        localStorage.setItem(
            'languageISOCode',
            result.languageISOCode || US_LANGUAGE_CODE
        );
        localStorage.setItem(
            'countryISOCode',
            result.countryISOCode || US_COUNTRY_CODE
        );
        updateCurrencyCode(result.currencyISOCode || US_CURRENCY_CODE);
        result?.englishPreferred != 'Y' &&
        result?.languageISOCode === 'ja' &&
        result?.salesOrgs &&
        result?.salesOrgs[0] === JAPAN_SALESORG
            ? i18n.changeLanguage('ja')
            : i18n.changeLanguage('en');
        yield put({ type: GET_USERPROFILE_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
        });
        yield put({
            type: GET_USERPROFILE_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
